export default "__VITE_ASSET__DFHBRMvM__"